export const createApiServerRoute = endpoint => (`https://onlineteercounter.xyz/${endpoint}`)
